export default __webpack_public_path__ + "images/SpeakersPhotos/Marta-Cordoba_AWS.jpg?be6ded05";